import { makeStyles } from '@material-ui/core';
import themes from 'styles/themes';

export const useStyles = makeStyles((theme) => {
    return {
        container: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            padding: '16px',
        },
        styleContainer: {
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            height: '100%',
            flexDirection: 'column',
        },
        fitContent: {
            width: '100%',
            height: '100%',
        },
        flexCenter: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        subtitle: {
            fontSize: '14px',
            fontFamily: 'PoppinsRegular',
            color: '#767676',
            textAlign: 'center',
            marginBottom: '16px',
        },
        cardContainer: {
            width: '85%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            flex: 1,
            justifyContent: 'center',
        },
        title: {
            fontSize: 24,
            fontWeight: 600,
            marginBottom: '30px',
            textAlign: 'center',
            fontFamily: 'Fraunces_120pt_SuperSoft_Wonky-Regular',
        },
        button: {
            width: '285px',
            height: 44,
            padding: 0,
            fontSize: 14,
            fontWeight: 600,
            fontFamily: 'PoppinsRegular',
            background: themes.palette.primary.main,
            borderRadius: '29px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textTransform: 'uppercase',
            border: 'none',
            marginTop: 18,
        },
    };
});
